
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/delivery",
      function () {
        return require("private-next-pages/help/delivery.tsx");
      }
    ]);
  